export var RetailTaxationType;
(function (RetailTaxationType) {
    RetailTaxationType[RetailTaxationType["PSN"] = 1] = "PSN";
    RetailTaxationType[RetailTaxationType["USN6"] = 3] = "USN6";
    RetailTaxationType[RetailTaxationType["OSN"] = 4] = "OSN";
    RetailTaxationType[RetailTaxationType["USN15"] = 5] = "USN15";
    RetailTaxationType[RetailTaxationType["AUSN8"] = 6] = "AUSN8";
    RetailTaxationType[RetailTaxationType["AUSN20"] = 7] = "AUSN20";
})(RetailTaxationType || (RetailTaxationType = {}));
